import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "rhapsody";
const groups = `${REACT_APP_API_PREFIX}/${service}/groups`;

export function getGroups(filters) {
  const url = `${groups}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getGroupById(id) {
  const url = `${groups}/${id}`;
  return {
    method: GET,
    url,
  };
}

export function updateGroup(id, body) {
  const url = `${groups}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteGroup(id) {
  const url = `${groups}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createGroup(body) {
  const url = `${groups}`;
  return {
    method: POST,
    url,
    body,
  };
}
